var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "15px",
    viewBox: "0 0 30 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ADC4F671-49A1-44EA-9C5C-F857C022B92B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "V1-mag-exemple",
    transform: "translate(-25.000000, -50.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "right-arrow",
    transform: "translate(40.000000, 57.500000) scale(-1, 1) translate(-40.000000, -57.500000) translate(25.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.801715,7.02172682 L29.801715,7.02172682 L22.9836919,0.237162535 C22.7387744,-0.0474225449 22.3083524,-0.0805979005 22.0223614,0.163173913 C21.7363704,0.406887421 21.7030312,0.835193505 21.9480073,1.11977859 C21.9708584,1.14630721 21.9957017,1.17108669 22.0223614,1.19376721 L27.6745068,6.82494856 L0.681784724,6.82494856 C0.305267997,6.82494856 0,7.12871588 0,7.50343998 C0,7.87816407 0.305267997,8.18187308 0.681784724,8.18187308 L27.6745068,8.18187308 L22.0223614,13.8062328 C21.7363704,14.0499463 21.7030312,14.4782524 21.9480073,14.7628375 C22.1929834,15.0474225 22.6233468,15.0805979 22.9093378,14.8368261 C22.9359975,14.8140873 22.9608994,14.7893661 22.9836919,14.7628375 L29.8017736,7.97827318 C30.0660852,7.71374491 30.0660852,7.2863717 29.801715,7.02172682 Z",
    id: "Path"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.f39e25327aabb84305c19181d9b85621.svg";
export { ForwardRef as ReactComponent };